export class ResizeImageRequestModel{
  image : File | null=null;
  target_width :number=0;
  target_height :number=0;
  maintain_aspectratio:boolean=true;
}

export class ResizeImageResponseModel{
  base64_image!:string;
  content_type!:string;

}
